import {
  SaleCard,
  SaleCardAdminLabel,
  SaleCardAdminMainValue,
  SaleCardAdminSecondaryValue,
  SaleCardsContainer,
  SaleCardsContent,
  YearEvolutionContainer,
} from "./financial.styles";
import { ReactComponent as TrendUp } from "../../../assets/images/trendUp.svg";
import { ReactComponent as TrendDown } from "../../../assets/images/trendDown.svg";
import { numberFormat } from "../../../helpers/utils";
import { formatCurrencyExtended } from "../../../helpers/currencyFormatter";
import { HalfPageModule, SectionTitle } from "../../../styles/global.styles";
import { FormattedMessage, useIntl } from "react-intl";
import { FinancialDataModel } from "../../../types/indicators.interfaces";
import { SocialFinancialCards } from "./SocialFinancialCards";

export function FinancialData(props: FinancialDataModel & { country?: string }) {
  const intl = useIntl();
  const country = props.country || 'es';
  
  // Get translated suffixes
  const sqmSuffix = intl.formatMessage({ id: 'sqmPriceSuffix' });

  return (
    <HalfPageModule>
      <SectionTitle>
        <FormattedMessage
          id="financial.title"
          values={{
            operation: props.operation == 1 ? "compra venta" : "alquiler",
          }}
        />
      </SectionTitle>
      <YearEvolutionContainer>
        <SaleCardsContent>
          <SaleCardsContainer>
            {props.evolution ? (
              <>
                {props.evolution.map((item) => (
                  <SaleCard key={item.boundary}>
                    {item.value < 0 ? <TrendDown /> : <TrendUp />}
                    <SaleCardAdminLabel>
                      <FormattedMessage id={`boundary.${item.boundary}`} />
                    </SaleCardAdminLabel>
                    <SaleCardAdminMainValue>
                      {item.value ? numberFormat.format(item.value) : "-"} %
                    </SaleCardAdminMainValue>
                    <SaleCardAdminSecondaryValue>
                      {item.valueSqm
                        ? formatCurrencyExtended(item.valueSqm, country, true, sqmSuffix)
                        : "-"}
                    </SaleCardAdminSecondaryValue>
                  </SaleCard>
                ))}
              </>
            ) : (
              <>
                {[10, 14, 15].map((boundaryId) => (
                  <SaleCard key={boundaryId}>
                    <SaleCardAdminLabel>
                      <FormattedMessage id={`boundary.${boundaryId}`} />
                    </SaleCardAdminLabel>
                    <SaleCardAdminMainValue>- %</SaleCardAdminMainValue>
                    <SaleCardAdminSecondaryValue>
                      - {sqmSuffix}
                    </SaleCardAdminSecondaryValue>
                  </SaleCard>
                ))}
              </>
            )}
          </SaleCardsContainer>
        </SaleCardsContent>
        <SaleCardsContent>
          <SocialFinancialCards social_financial={props.social_financial} country={country} />
        </SaleCardsContent>
      </YearEvolutionContainer>
    </HalfPageModule>
  );
}
